(function () {
    angular
        .module('app')
        .directive('swipervideo', setswipervideo);

    setswipervideo.$inject = ['$timeout', '$window'];
    function setswipervideo($timeout, $window) {
        return {
            link: function (scope, element, $attrs) {
                return $timeout(function () {
                    let videos = element[0].querySelectorAll('.vlite-video');
                    let swiper;
                    videos.forEach((video, i) => {
                        let poster;
                        let options = {
                            controls: true,
                            volume: true,
                            fullscreen: true,
                            loop: false,
                            muted: false,
                            playPause: true,
                            progressBar: true,
                            time: true,
                            bigPlay: true,
                            autoplay: false,
                        };
                        let provider = null;

                        if (video.classList.contains('vimeo')) {
                            provider = "vimeo";
                        }
                        if (video.classList.contains('youtube')) {
                            provider = "youtube";
                        }
                        if(video.dataset.poster) {
                            poster = video.dataset.poster;
                        }
                        let vliteConfig = {
                            options: options,
                        };

                        if (provider) {
                            vliteConfig.provider = provider;
                        }
                        if (poster) {
                            vliteConfig.options.poster = poster;
                        }
                      
                        new $window.Vlitejs(video, vliteConfig)

                    });

                    swiper = new Swiper(element[0], {
                        loop: false,
                        // slidesPerView: 2,
                        spaceBetween: 24,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            type: "fraction",
                        },
                        breakpoints: {
                            0: {
                              slidesPerView: 1,
                            },
                            768: {
                              slidesPerView: 2,
                            },
                            900: {
                              slidesPerView: 1,
                            },
                            1200: {
                              slidesPerView: 2,
                            }
                        }
                    });
                   
                });

            }
        };
    }
})();
